import { useCurrentUser } from '@/shared/composables/current-user'
import { useGuestAuth } from '@/shared/composables/guest-auth'
import { Room } from '@/shared/types/store'

export const isCurrentUserRoomMember = (room: Room | undefined): boolean => {
  if (!room) {
    return false
  }

  const { currentUser } = useCurrentUser()
  const { currentGuest } = useGuestAuth()

  if (currentGuest.value) {
    return room.guests?.has(currentGuest.value.pServed) ?? false
  }

  const imLogin = currentUser.value?.imLogin
  if (!imLogin) {
    return false
  }

  if (room.contacts?.some((contact) => contact.id === imLogin)) {
    return true
  }

  return [...(room.subscribers ?? [])].some(([, member]) => member.imLogin === imLogin)
}
